import { useNavigate, useLocation } from "react-router-dom";
import { useAtom, useAtomValue } from "jotai";
import { Popover, Whisper } from "rsuite";
import { useRef, useEffect } from "react";

import GCLogo from "../../assets/img/growthcloud/growthcloud_wordmark.svg";
import NavbarAccountOptions from "components/Options/NavbarAccountOptions";
import CloudNotifications from "./CloudNotifications/CloudNotifications";
import { tenantIDAtom } from "../../atoms/GlobalAtoms";
import AppSpotlight from "../../context/AppSpotlight";
import GlobalSearchNavbar from "./GlobalSearchNavbar";
import { sidebarOpenAtom } from "atoms/SidebarAtoms";
import CloudSettingsLink from "./CloudSettingsLink";
import MarketplaceLink from "./MarketplaceLink";
import Constants from "../../utils/Constants";
import { IsMobileAtom } from "../../App";

const modules = Constants.MODULES;

const CRMNavbar = ({ mode = "cloud", isCloudSupportal = false }) => {
  const accountOptionsRef = useRef();
  const closeAccountOptions = () => accountOptionsRef?.current?.close();
  const [open, setOpen] = useAtom(sidebarOpenAtom);
  const isMobile = useAtomValue(IsMobileAtom);
  const tenantID = useAtomValue(tenantIDAtom);
  const location = useLocation();
  const navigate = useNavigate();

  // Color fix when coming from Supportal.
  useEffect(() => {
    const path = window.location.href;

    for (let i = 0; i < modules.length; i++) {
      if (path.indexOf(modules[i].Slug) >= 0) {
        window.root.style.setProperty("--primary", modules[i].Color);
        return;
      }
    }

    window.root.style.setProperty("--primary", Constants.THEME.PRIMARY);
  }, [location]);

  return (
    <>
      <header>
        <nav
          className="d-flex align-items-center justify-content-between px-2 position-fixed bg-white"
          style={{
            boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
            height: 50,
            top: 0,
            zIndex: 3,
            width: isMobile
              ? "100%"
              : mode === "account"
              ? "100%"
              : open
              ? "calc(100% - 250px)"
              : "calc(100% - 50px)",
          }}
        >
          <div
            className="d-block d-md-none navbar-sidebar-toggler cursor-pointer"
            onClick={() => {
              setOpen(!open);
            }}
          >
            <div className="inner">
              <i className="mdi mdi-menu"></i>
            </div>
          </div>
          {mode === "cloud" && <GlobalSearchNavbar />}
          {mode === "account" && (
            <div className="d-flex px-2">
              <img
                alt=""
                src={GCLogo}
                style={{ width: 180, marginRight: 50, marginLeft: 10 }}
                className="d-none d-md-block ml-0 cursor-pointer"
                onClick={() => navigate(`/clouds/${tenantID}/activity`)}
              />
              <div
                className="d-flex align-items-center font-weight-500 text-dark px-3"
                style={{ height: 50, borderBottom: "4px solid var(--primary)" }}
              >
                <span className="mt-1">Account Settings</span>
              </div>
            </div>
          )}
          <div className="d-flex">
            {mode === "cloud" && !isCloudSupportal && <CloudNotifications />}
            {mode === "cloud" && !isCloudSupportal && <MarketplaceLink />}
            {mode === "cloud" && <CloudSettingsLink />}
            <Whisper
              placement="autoVerticalEnd"
              controlId="nav-settings"
              preventOverflow
              trigger="click"
              ref={accountOptionsRef}
              speaker={
                <Popover className="sidebar-popover">
                  <NavbarAccountOptions onClose={closeAccountOptions} />
                </Popover>
              }
            >
              <span>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="nav-link d-md-none cursor-pointer pl-1 pr-0"
                  style={{ position: "relative" }}
                >
                  <span className="avatar avatar-sm rounded text-capitalize text-center link-hovered bg-white text-secondary">
                    <i
                      className="mdi mdi-account"
                      style={{
                        fontSize: "24px",
                        position: "relative",
                        top: 1,
                      }}
                    ></i>
                  </span>
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="nav-link d-none d-md-block cursor-pointer pl-1 pr-0"
                >
                  <span className="avatar avatar-sm rounded text-capitalize text-center link-hovered bg-white text-secondary">
                    <i
                      className="mdi mdi-account"
                      style={{
                        fontSize: "24px",
                        position: "relative",
                        top: 1,
                      }}
                    ></i>
                  </span>
                </a>
              </span>
            </Whisper>
          </div>
        </nav>
      </header>
      <AppSpotlight />
    </>
  );
};

export default CRMNavbar;
